<template>
    <div class="px-0 pb-4 container-fluid">
        <!-- show nav button -->
        <button class="float-left mt-1 ml-1 mr-1 btn btn-primary fadeIn sticky-top" v-if="!showNav" @click="showNav = true">
            <font-awesome-icon icon='ellipsis-v'></font-awesome-icon>
        </button>
        <!-- side menu list -->
        <div style="position:fixed" v-if="showNav" class="fadeIn">
            <div class="side-menu-wrapper"></div>
        </div>
        <div class="side-menu-list fadeIn" v-if="showNav">
            <!-- side logo -->
            <div style="position:fixed">
                <div class="side-logo-wrapper"></div>
                <div class="side-logo animate__animated animate__rubberBand">
                    <img :src="$store.state.logo" :alt="$store.state.applicationName" class="img-fluid">
                </div>
            </div>
            <!-- side content : login - logout -->
            <div style="position:fixed">
                <div class="side-content">
                    <div class="d-flex flex-column">
                        <router-link tag="button" to="/user-login" class="mb-1 btn btn-primary" v-if="$store.state.authUser.guest">
                            <font-awesome-icon icon='login-asahi'></font-awesome-icon>
                            Login
                        </router-link>
                        <div v-else class="mb-1">
                            <div class="flex-wrap mb-1 d-flex">
                                <div class="mb-1 mr-1 badge badge-secondary">{{ $store.state.authUser.detail.user.name }}</div>
                                <div class="badge badge-light">{{ $store.state.authUser.detail.role.name }}</div>
                            </div>
                            <button class="btn btn-primary" style="white-space: nowrap;" @click="logout()">
                                <font-awesome-icon icon='sign-out-alt'></font-awesome-icon>
                                Logout
                            </button>
                        </div>
                        <button class="btn btn-primary" @click="showNav = false">
                            <font-awesome-icon icon='eye-slash'></font-awesome-icon>
                            Tutup
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <!-- top menu list -->
            <navbar-menu-list v-if="showNav" :menu-list="$store.getters['page/pageNested']({ showAll : false })" class="text-center top-menu-list fadeIn"
            navbarClass="nav justify-content-between" icon-size="3x" icon-position="top">
        </navbar-menu-list>

        <!-- content view : as router later -->
        <div class="mt-3 main-content" :class="[(showNav == true) ? '' : 'ml-0']">
            <transition name="custom-classes-transition"
            :enter-active-class="$store.state.animatedClass.routerTransition.parent.enterActiveClass"
            :leave-active-class="$store.state.animatedClass.routerTransition.parent.leaveActiveClass"
            :mode="$store.state.animatedClass.routerTransition.parent.mode">
            <router-view />
            </transition>
        </div>


        <!-- quick menu -->
        <ul class="text-center quick-menu nav nav-tabs justify-content-center" v-if="showNav">
            <li class="nav-item">
                <router-link :to="{ name: 'sale-form' }" class="nav-link">
                    <span>
                        <font-awesome-icon icon="sale-asahi" size="3x"></font-awesome-icon>
                        <div></div>
                        Penjualan
                    </span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'purchase-form' }" class="nav-link">
                    <span>
                        <font-awesome-icon icon="purchase-asahi" size="3x"></font-awesome-icon>
                        <div></div>
                        Pembelian
                    </span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'stock-recap' }" class="nav-link">
                    <span>
                        <font-awesome-icon icon="stock-asahi" size="3x"></font-awesome-icon>
                        <div></div>
                        Saldo Stok
                    </span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'sale-daily-report' }" class="nav-link">
                    <span>
                        <font-awesome-icon icon="report-asahi" size="3x"></font-awesome-icon>
                        <div></div>
                        Lap.Penjualan Harian
                    </span>
                </router-link>
            </li>
        </ul>

        <!--<inspiring-info></inspiring-info>-->

        <footer-side></footer-side>

    </div>
</template>

<script>
    import NavbarMenuList from './../asahi/component/NavbarMenuList.vue';

    import menuList from './../menuList.json'

//    import InspiringInfo from './childs/InspiringInfo.vue'
    import FooterSide from './childs/Footer.vue'

    export default {
        name: "HomeDesktop",
        components: {
            NavbarMenuList,
 //           InspiringInfo,
            FooterSide
        },

        data() {
            return {
                menuList,

                showNav: true
                // bgStyle: {
                //     // 'position': 'fixed',
                //     'top': 0,
                //     'right': 0,
                //     'bottom': 0,
                //     'left': 0,
                //     'background-size': 'cover',
                //     'background-position': '50% 50%',
                //     'background-image': 'url("https://mdbootstrap.com/img/Photos/Horizontal/Nature/full page/img(20).jpg")',
                //     // 'background-image': 'url("image/asahi/background.jpg")',
                //     'background-repeat': 'repeat',
                //     'background-attachment': 'fixed',
                //     // 'z-index': -1
                //     /* //
                //     opacity: 1
                //     background-color:rgba(0, 0, 0, 0.5)
                //     */
                // }
            };
        },
        methods: {
            async logout() {
                await this.$store.dispatch('authUser/logoutAuth')
                this.$router.push({name : 'welcome'})
            }
        }
    };

</script>

<style lang="scss" scoped>
    $sideMenuWidth:200px;

    .side-menu-wrapper {
        position: absolute;
        background-color: rgba(59, 64, 69, 0.8);
        height: 100vh;
        width: $sideMenuWidth;

        transform: skew(-10deg);
        -webkit-transform: skew(-10deg);
        -moz-transform: skew(-10deg);
        -o-transform: skew(-10deg);
        margin-left: -60px;
        z-index: -1;
    }

    .side-menu-list {
        position: absolute;
    }

    .side-logo-wrapper {
        position: absolute;
        background-color: #fdd32aff;
        height: 25vh;
        width: $sideMenuWidth;

        transform: skew(-10deg);
        -webkit-transform: skew(-10deg);
        -moz-transform: skew(-10deg);
        -o-transform: skew(-10deg);
        margin-left: -30px;
        z-index: -1;
        box-shadow: 1px 1px 7px white;
    }

    .side-logo {
        width: 150px;
        margin-top: 10px;
        margin-left: 10px
    }

    .side-content {
        width: $sideMenuWidth / 2;
        margin-top: 40vh;
        margin-left: 15px;
        font-size: 20px
    }

    .main-content {
        margin: 0px 0px 10px $sideMenuWidth;
    }

    .top-menu-list {
        background-image: linear-gradient(to right, rgba(59, 64, 69, 0.5), rgba(59, 64, 69, 1));
        margin-left: $sideMenuWidth;
        position: sticky;
        top: 0;
        z-index: 3;
    }

    // reference : http://jsfiddle.net/K3bQJ/6/ , https://stackoverflow.com/questions/11418977/parallelogram-navigation-background-with-css#answer-11419169
    //parallelogram-nav : use ul>li>a>span(list inside this)
    .quick-menu {
        // padding: 20px;
        margin-left: $sideMenuWidth;

        & li {
            // float: left;
            margin-right: 2px;
            // display: inline-block;
            // zoom: 1;
            // *display: inline;
            // position: relative;

            & a {
                display: inline-block;
                text-decoration: none;
                padding: 4px 10px;
                border-radius: 3px;
                transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -webkit-transform: skew(-10deg);
                color: #fff;
                width: 170px;
                cursor: pointer;


                & span {
                    display: inline-block;
                    transform: skew(10deg);
                    -o-transform: skew(10deg);
                    -moz-transform: skew(10deg);
                    -webkit-transform: skew(10deg);

                }
            }
        }
    }

</style>
